import React, { useCallback } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { GestureResponderEvent } from 'react-native';

import ActionButton from 'components/action-button';
import { CustomEventNames } from 'state/amplitude/constants';
import { t } from 'state/intl/translations';

import { IPlaceOrderButtonProps } from './types';

const PlaceOrderButton: React.FC<React.PropsWithChildren<IPlaceOrderButtonProps>> = ({
  placeOrderAriaLabel,
  disabled,
  onPress,
  isLoading,
  confirmation,
}) => {
  const placeOrderTextKey = confirmation ? 'placeSecureOrder' : 'continue';
  const placeOrderText = t(placeOrderTextKey, {
    secureOrderIcon: '',
  });

  const onPressWithReset = useCallback(
    (ev: GestureResponderEvent) => {
      onPress && onPress(ev);
    },
    [onPress]
  );

  return (
    <ActionButton
      _text={{ fontSize: 'xl' }}
      fullWidth
      eventAttributes={{ Name: CustomEventNames.BUTTON_CLICK_PLACE_ORDER }}
      onPress={onPressWithReset}
      accessibilityLabel={confirmation ? placeOrderAriaLabel : undefined}
      accessibilityRole="button"
      testID={confirmation ? 'place-order' : 'continue-order'}
      disabled={disabled}
      isLoading={isLoading}
      startIcon={confirmation ? <Icon variant="locked" /> : undefined}
    >
      {placeOrderText}
    </ActionButton>
  );
};

export default PlaceOrderButton;
